import { isFinanceProject, isGlobalProject } from 'config';
import { applySchema } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import {
  placeOfBirthSchema,
  PlaceOfBirthFormType,
} from 'modules/client/common/forms/placeOfBirthForm';
import {
  ReasonChangeFormType,
  reasonChangeSchema,
} from 'modules/client/common/forms/reasonChangeForm';

import { CitizenshipFormType, citizenshipsSchema } from './citizenshipForm';
import {
  getIdentityDocumentSchema,
  IdentityDocumentFormType,
} from './identityDocumentForm';
import {
  PepConnectionFormType,
  getPepConnectionSchema,
} from './pepConnectionForm';
import {
  PersonalDataFormType,
  getPersonalDataSchema,
} from './personalDataForm';
import {
  BaseLegalClientHeadPositionFormType,
  getBaseLegalClientHeadPositionFormSchema,
} from './positionInCompanyForm';
import {
  RegistrationAddressFormType,
  registrationAddressSchema,
} from './registrationAddressForm';
import {
  ResidentialAddressFormType,
  residentialAddressWithFilesSchema,
} from './residentialAddressForm';
import {
  TaxResidencyFormType,
  getTaxResidencesSchema,
} from './taxResidencyForm';

export interface LegalClientFirstHeadFormType
  extends BaseLegalClientHeadPositionFormType,
    PersonalDataFormType,
    CitizenshipFormType,
    TaxResidencyFormType,
    RegistrationAddressFormType,
    ResidentialAddressFormType,
    PepConnectionFormType,
    PlaceOfBirthFormType,
    ReasonChangeFormType,
    IdentityDocumentFormType {}

export const getSchema = (
  t: TFunc
): ObjectSchema<LegalClientFirstHeadFormType> => {
  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();

  return object()
    .concat(getPersonalDataSchema(t))
    .concat(citizenshipsSchema)
    .concat(getTaxResidencesSchema())
    .concat(applySchema(isFinance, registrationAddressSchema))
    .concat(applySchema(isGlobal, placeOfBirthSchema))
    .concat(residentialAddressWithFilesSchema)
    .concat(getBaseLegalClientHeadPositionFormSchema(t))
    .concat(getPepConnectionSchema(t, { notRequestInformation: isGlobal }))
    .concat(reasonChangeSchema)
    .concat(applySchema(isGlobal, getIdentityDocumentSchema()));
};

export const { Field, Form, useFormContext, Submit } =
  TypedForm<LegalClientFirstHeadFormType>();

export type FormErrors = FormErrorsBase<LegalClientFirstHeadFormType>;
